export const skillsStrings = {
    en: {
        skillsTitle: "Skills",
        skillsSubtitle: "My Skills",
        skillsProgramming: "Programming",
        skillsDatabases: "Databases",
        skillsDevOps: "DevOps",
        skillsOther: "Other",
    },
    pl: {
        skillsTitle: "Umiejętności",
        skillsSubtitle: "Moje Umiejętności",
        skillsProgramming: "Programowanie",
        skillsDatabases: "Bazy danych",
        skillsDevOps: "DevOps",
        skillsOther: "Pozostałe",
    },
};

export default skillsStrings;
